import React, { Component } from "react";
import _ from "lodash";
import { Div, Image } from "atomize";
import ImageLink from "./ImageLink";
import { IsValidUrl } from "../../utilities/helpers";

export default class BrandImages extends Component {
  render() {
    const { content } = this.props;

    return (
      <Div>
        <Div
          bg="#1f1f1f"
          p={{ y: { md: "1rem" }, x: { md: "3rem" } }}
          d="flex"
          justify={{ xs: "space-around", md: "space-between" }}
          align="center"
          flexWrap={{ xs: "wrap", md: "no-wrap" }}
          //m={{ t: "5.375rem" }}
        >
          {_.get(content, "brandImages", []).map((image, index) => {
            return (
              <Div
                key={index}
                p={{
                  x: { xs: "2rem", md: "0" },
                  y: { xs: "2.75rem", md: "0" },
                }}
              >
                <ImageLink link={image.imgLink}>
                  <Image
                    src={image.img}
                    alt={image.alt && image.alt}
                    maxW="4.7rem"
                    bgSize="contain"
                    bgRepeat="no-repeat"
                  />
                </ImageLink>
              </Div>
            );
          })}
        </Div>
      </Div>
    );
  }
}
